module.exports = __webpack_public_path__ + "img/bg.bb4247fb.png";